import React from 'react'
import { mount } from 'enzyme'
import AdminCircle from '../AdminCircle'

describe('<AdminCircle />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      admin: {
        link: 'test link',
        name: 'test admin'
      }
    }
    wrapper = mount(<AdminCircle {...props} />)
  })
  it('should render without crashing', () => {
    mount(<AdminCircle {...props} />)
  })
  it('should render the admin\'s name', () => {
    expect(wrapper.find('AdminCircle__AdminName').text()).toBe(props.admin.name)
  })
  it('should link to the admin\'s page', () => {
    expect(wrapper.find('a').prop('href')).toBe(props.admin.link)
  })
})
